import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-myleads',
  templateUrl: './myleads.component.html',
  styleUrls: ['./myleads.component.css']
})
export class MyleadsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
